// atentie cu id-urile dynamice !!!----
function id2elm(o) {
    /**
     * accepta dom_element, string sau #string
     * intoarce  dom element
     */
    return typeof o === "object" ? o : /^(\s)*#/.test(o) ? Q(o) : Q("#" + o);
}


var global_loader_place; // o sa fie top_bar
function generate_loader(o) {
    let T, L;
    if (o.loader === "circle") {
        (T = _E("<div style='position:fixed;z-index:3000000'></div>")),
            (L = _E().setC("circular_loader"));
        T._(L);
        document.body._top(T);
    } else {
        var tg = id2elm(o.target);
        var k = !!o.loader,
            type = k ? "element_loader" : "global_loader",
            place = k ? tg : o.place || global_loader_place || document.body,
            l = _E(type);
        T = _E("<div style=position:relative></div>");
        if (o.loader instanceof Element) {
            l = o.loader;
            place = o.loader_place || document.body;
        }
        T._(l);
        place._top(T);
        setTimeout(function () {
            var top = (place.offsetHeight - l.offsetHeight) / 2,
                left = (place.offsetWidth - l.offsetWidth) / 2;
            l.css("left:" + left + "px;top:" + top + "px;opacity:.9");
        }, 0);
    }
    return T;
}

// ex : Q.ajax({src:"ret.php?a=1&b=55",data:{D:444},cb:Q.i,loader:'circle',cache:0})

Q.ajax = function (o = {}) {
    o = { method: "POST", cb: nf, ...o };
    var ldr,
        req = new XMLHttpRequest(),
        cb = o.cb.bind(req);

    if (o.type && o.type !== "xml") {
        req.responseType = o.type;
    }

    if (typeof o.mem === 'object') { //  caller  can control current request --- ex call_obj.xhr.abort();
        o.mem.xhr = req;  // ex x-table.fetch stie ca are un request si daca apare unul nou face cancel 
    }
    // show loader
    req.onloadstart = function (ev) {
        if (o.loader !== 0 && o.loader !== false) {
            ldr = generate_loader(o);
        }
    };

    // handle abort
    req.onabort = function (ev) {
        ldr && ldr.die(-1);
        (o.abort || nf)();
    };

    // handle response
    req.onreadystatechange = function (ev) {
        if (req.readyState === 4) {
            ldr && ldr.die(0.3);
            if (req.status === 200) {
                // DONE
                o.type === "xml" ? cb(req.responseXML) : cb(req.response);
            } else {
                // FAIL
                var msg =
                    "<div style='margin:0 0 .5em 0'>SRC:<e style='color:#bdf;'>\"" +
                    o.src.split("?")[0] +
                    '"</e></div><sad></sad> ' +
                    req.statusText +
                    "!";
                if (o.fail) {
                    o.fail(msg, req);
                } else {
                    if (req.status > 0) {
                        dn(msg, "ERROR [" + req.status + "]");
                    } else {
                        // console.log(req.status);  // aborted 
                    }
                }
            }
            //req.abort(); // ???? aiurea 
        }
    };

    // eroror
    req.onerror = function (evt) {
        ldr && ldr.die(0.3);
        // console.log(gettype(evt));
        dn("Connection Problems!<br/>ERROR: " + gettype(evt), "NETWORK");
    };

    // handling timeout
    req.timeout = Number.isFinite(Q.ajax_timeout) ? +Q.ajax_timeout : Number.isFinite(o.timeout) ? +o.timeout : 30000;
    req.ontimeout = function () {
        dn("connection is weak | server execution too long", "NETWORK");
        ldr && ldr.die(0.3);
    };

    // progress -- read 
    if (o.onprogress instanceof Function) {
        let lastIndex = 0;
        req.onprogress = function () {
            const newChunk = req.responseText.slice(lastIndex);
            lastIndex = req.responseText.length;
            o.onprogress(newChunk, req);
        };

    }



    // prepare data
    var D,
        d = o.data;
    if (o.method === "POST") {
        switch (gettype(d)) {
            case "String":
                D = new FormData();
                D.append("code_to_eval", d);
                break;
            case "Object":
                D = new FormData();
                for (var v in d) {
                    // previn trimitere de tag
                    !(d[v] || {}).tagName && D.append(v, typeof d[v] === "string" ? d[v] : JSON.stringify(d[v]));
                }
                break;
            case "HTMLFormElement":
                D = new FormData(d);
                break;
            default:
                D = d; //  FormData
        }
    } else {// GET
        o.src += /\?/.test(o.src) ? "&" : "?";
        for (let [k, v] of Object.entries(d || {})) {
            o.src += "&" + k + "=" + v;
        }
    }


    // token -- send back to server -- ex class.__code__::token_check()  --  see class.__code__.php
    var token = new URLSearchParams(location.search).get("token");
    if (token) {
        if (o.method === "POST") {
            D?.append("token", token);
        }
        else {
            o.src += (/\?/.test(o.src) ? "&" : "?") + "token=" + token;
        }
    }




    // open connection to server
    req.open(o.method, o.src);

    var headers = o.headers || {};

    // HTTP Basic Auth
    if (o.user) {
        o.auth = o.user + ':' + o.pass
    }
    if (o.auth) {
        var credentials = btoa(o.auth); // "USER:PASSWORD";
        headers.Authorization = `Basic ${credentials}`;
    }

    // request headers (sended from client)
    for (let h in o.headers) {
        let v = o.headers[h];
        req.setRequestHeader(h, Object.isExtensible(v) ? JSON.stringify(v) : v);
    }
    // ca sa stiu pe ce interfatza e inplucit
    req.setRequestHeader("client_interface", history.now?.interface);
    req.setRequestHeader("client_action", history.now?.action);
    //launch request
    req.send(D || null);
    return req;
};

var loadEvent;

// NAVIGATION -- previn navigarea pt  session.changes=true
window.addEventListener("popstate", function (ev) {
    if (loadEvent) return; /* atentie Safary lanseaza dupa reload si popstate */
    exitTinyFullscreenSafely();
    killPops();
    history.set_sense(ev);
    // BACK navigation means discard TinyMCE edits
    if (history.sense === "back") {
        SS.pointer("tinymce", false); // drop edits + undo/redo
    }
    if (+history.cursor < 0) {
        //   history.clear seteaza cursor=0 si opreste back
        history.go(1);
        return;
    }
    if (Q.bool(SS.changes) || Blinder.changes) {
        if (!SS.history_return) {
            SS.history_return = 1;
            history.go(history.sense === "back" ? 1 : -1);
        } else {
            SS.removeItem("history_return");
            setTimeout(function () {
                dn("<h4><wrn></wrn>&nbsp;UNSAVED_CHANGES&nbsp;</h4>", "WARNING", 1500);
                edit_btn.tmpA("shake");
            }, 200);
        }
    } else {
        history.ajaxify(ev);
    }
});

function exitTinyFullscreenSafely() {
    if (window.tinymce) {
        const editor = tinymce?.activeEditor;

        if (editor && editor.plugins?.fullscreen?.isFullscreen()) {
            editor.execCommand('mceFullScreen'); // proper toggle OFF
        }

        // hard fallback (SPA safety)
        document.documentElement.classList.remove('tox-fullscreen');
        document.body.classList.remove('tox-fullscreen');
        document.body.style.overflow = '';
    }
}


// RELOAD
window.addEventListener("load", function (ev) {
    // las  ajaxify  abia dupa session.check care este asincron
    loadEvent = 1; // previn popstate parazit
    setTimeout(function () {
        loadEvent = 0;
    }, 100);
});

// enhance HISTORY -- for single_page_application
{
    Object.defineProperty(history, "record", {
        value: function (obj) {
            var o = { mode: "get", ...obj }.drop([
                "cb",
                "target",
                "chain",
                "record",
                "clear",
                "method",
            ]); // nu pot memora elementele neserializabile --- EP.get nu poate avea cb daca vreau sa pun in history
            history.pushState(
                { href: location.href, ajax: o, timeStamp: Date.now() },
                "",
                ""
            );
            history.set_sense({ type: "popstate" });
            LS.pointer(["tab_list", broadcast.id], o);
            //  h_mon();
            //report_client_context(); // redundant
        },
        enumerable: true,
    });
    Object.defineProperty(history, "ajaxify", {
        value: function (ev = {}) {
            if (!history.state) {
                var O;
                if (SS.last_history_state) {
                    var O = SS.last_history_state.parsed.ajax;
                    delete SS.last_history_state;
                    history.record(
                        O.tail({ timeStamp: Date.now() + 1, recover: 1 })
                    );
                    history.ajaxify({ type: "recover" });
                    return;
                } else {
                    history.replaceState(
                        {
                            href: location.href,
                            ajax: { src: "/structure/home.php", mode: "get" },
                            timeStamp: Date.now(),
                        },
                        ""
                    );
                    MAIN.get({
                        src: "/structure/home.php",
                        fail: () => {
                            dn(
                                "AHA engine is especting <m style='color:#bdf'>\"/structure/home.php\"</m> file for site entry<hr/>" +
                                location,
                                "WARNING"
                            );
                        },
                    });
                }
            } else {
                var O = history.state.ajax;
                if (O?.mode === "tpl") {
                    template({
                        ...O,
                        into: MAIN,
                        clear: 1,
                        record: ev.type === "recover" ? 1 : 0,
                    }).then(() => {
                        if (ev.type === "recover" && session.changes) {
                            Blinder.show({
                                title: "<h3 c>EDITED DATA RECOVERY</h3>",
                                html:
                                    "<wrn>NETWORK WAS DOWN</wrn><hr/><big i>You have " +
                                    (session.stack.length - 1) +
                                    " CHANGES. <br/>Please inspect your work <m k>(SAVE or DROP CHANGES)</m>!</big>",
                                ok: nf,
                            });
                        }
                    });
                } else {
                    MAIN.get(O);
                }
            }
            Q.AST.awake = false;
            LS.pointer(["tab_list", broadcast.id], history.now);
        },
        enumerable: true,
    });
    Object.defineProperty(history, "set_sense", {
        value: function (ev = {}) {
            if (ev.type === "popstate") {
                // navigare ajax
                if (+SS.time_ref > history.state.timeStamp) {
                    history.sense = "back";
                    history.cursor--;
                } else {
                    history.sense = "forword";
                    history.cursor++;
                }
            } else {
                history.sense = "load";
                if (ev.type === "recover") {
                    history.cursor++;
                }
            }
            SS.time_ref = history.state.timeStamp;
            SS.history_cursor = history.cursor;
        },
        enumerable: true,
    });
    Object.defineProperty(history, "clear", {
        value: function () {
            SS.history_cursor = 0;
            SS.changes = 0;
            location = "/";
            history.replaceState(
                {
                    href: location.href,
                    ajax: { src: "/structure/home.php", mode: "get" },
                    timeStamp: Date.now(),
                },
                ""
            );
        },
        enumerable: true,
    });
    Object.defineProperty(history, "cursor", {
        value: SS.history_cursor || 0,
        writable: true,
        enumerable: true,
    });
    Object.defineProperty(history, "now", {
        get: function () {
            return this.state ? this.state.ajax : {};
        },
        enumerable: true,
    });
    Object.defineProperty(history, 'set', {
        value: function (k, v) {
            let
                O = Object.isExtensible(k) ? k : Object.create({ k, v }),
                state = history.state;
            for (let i in O) {
                state.ajax.pointer(i, O[i]);
            }
            history.replaceState(state, "", "");
        }
    });
    Object.defineProperty(history, 'rem', {
        value: (...A) => {
            state = history.state;
            A.map(prop => {
                delete state.ajax[prop];
            });
            history.replaceState(state, "", "");
        }
    })
    Object.defineProperty(history, "keep", {
        //  memorez chestii pt navigarea intre interfetze
        // -- ex selectez un rind din x-table ma duc in interfata de edit (alta decat cea curenta) si cand ma intorc browser.back refac selected_row
        get: function () {
            return this.state.ajax.keep;
        },
        set: function (obj) {
            var state = history.state;
            state.ajax.keep = obj;
            history.replaceState(state, "", "");
        },
        enumerable: true,
    });

    report_client_context = function () {
        var F = new FormData();
        F.load(
            history.now === "START"
                ? { START: new Date().datetime }
                : history.now
        );
        return fetch("/aha/io.php?keyword=client_context", {
            method: "POST",
            body: F,
        })
            .then((r) => r.json())
            .then((o) => {
                return o;
            });
    };

    /*
    function h_mon() {
        Q.monitor({ sense: history.sense, length: history.length, cursor: history.cursor, ...history.state }, { add: 1 });
    }
    */
}

// SCRIPT EVAL
evalScripts = function (elm, x, which) {
    var scripts = !x
        ? elm.querySelectorAll("script")
        : !which
            ? elm.querySelectorAll("xscript")
            : elm.querySelectorAll("xscript[" + which + "]");
    var allScripts = "var _i= this;"; // f tare --- acu am si la  ELM.get() adresarea cu _i in js code;
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].hasA("src")) {
            // reapend script tag for execution
            var sc = _E("script").setA({
                type: "text/javascript",
                src:
                    scripts[i].src //+(/\?v=/.test(scripts[i].src) ? "" : "?" + Date.now())
            });
            sc.on("load", function () {
                //slg({loaded: this.src});
            });
            sc.oust(scripts[i]);
        }
        allScripts = allScripts + scripts[i].innerHTML + ";";
    }
    allScripts && setTimeout(new Function(allScripts).bind(elm), 0); // evaluate inline scripts
};
EP.run = function (path) {
    evalScripts(this);
    return this;
};
EP.runx = function (which) {
    evalScripts(this, 1, which);
    return this;
};

/*
 * ex1 : ELM.get({
 *   src:"path/file_name",
 *   cb:function($){
 *      // se executa dupa popularea ELM :  _i este ELM  si this este tot ELM
 *   },
 *   data:{project:1,action:3} // --> $_POST
 * })
 *
 * ex2 : ELM.get({src:"..."}).then(do smth);
 *
 * ex3 : ELM.get({src:"site.css",loader:"circle",cache:0})
 *
 *
 * !!!BAC>>>  REGULA de insertie pt css si js relative la path-ul sursei lui get
 * <script src="./sub_path/a_file.js"></script>  deci cu ./  musai
 * la fel si pt css  <link href="./sub_path/a_file.css"/> deci ./ inseamna relativ --- aceasi regula ca si la import module nativ js
 */

EP.get = function (o = {}) {
    if (this.id === "MAIN") {
        if (session.changes) {
            dn(
                "<h4><wrn></wrn>&nbsp;UNSAVED&nbsp;CHANGES</h4>",
                "WARNING",
                1500
            );
            console.log("MAIN.get --- unsaved changes");
            //monitor();
            return;
        } else {
            edit_switch.active = 0;
            edit_switch.visible = false;
        }
    }
    var o = { ...o };
    o.src = o.src || o.href;
    if (!o.src) return;
    var $ = this,
        then = (o.then || nf).bind($),
        CH = {};
    CH.promise = new Promise((a, b) => {
        CH.resolve = a;
        CH.reject = b;
    });
    let XHR;
    o.cb = function (content) {
        var error = (this.getResponseHeader("error") || "")
            .replace(/^<span>/, "")
            .replace(/<\/span>$/, "");
        var ER = this.header("error_code");
        if (error || ER) {
            if (error) {
                dn(error.trim(), "ERROR");
            }
            if (ER) {
                Q.modules("~.error_code_handlers")
                    .then((M) => {
                        if (M[ER] instanceof Function) {
                            M[ER](error);
                        } else {
                            dn(
                                (M[ER] || ER) +
                                (M[ER]
                                    ? ""
                                    : "<hr/><m bc>~.error_code_handlers</m> has no <m yc>" +
                                    ER +
                                    "</m> definition"),
                                "ERROR <m bc>-- " + ER + " --</m>"
                            );
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        dn(err);
                    });
            }
            return;
        }
        if ($.id === "MAIN") {
            body.remA("forced_layout");
            if (o.record) {
                history.record({ mode: "get", src: o.src });
            }

            window.config_interface_tools && config_interface_tools(true);
            all_menu_buttons.remA("memorize");
            all_menu_buttons.remA("commit");
            document.documentElement.scrollTop = 0;
            delete SS.editing;
            status_write(
                "<span style='color:#ffa'>" +
                "GET" +
                "</span> " +
                o.src.replace(/\.[^\.]*?$/, "")
            );
            //$.fire("popstate");  --  loop reloading  !!!!! -- e futere

            // NU NU NU
            // daca ies direct din memorize interface tre sa curat
            //                session.edited_data = {};
            //                session.editing = null;
            // e treaba lui template sa face asta la session_exit_edit mode ----
            // deci NU trebuie fortat session ca se pierde la navigare tot ce s-a editat
        }

        /*  !!!BAC>>>  refacerea mecanismului de adresare relativa a resurselor  */
        {
            var rgx_js = /(src\s*=.*?)\.\/(.*?\.js)/gim,
                rgx_css = /(href\s*=.*?)\.\/(.*?\.css)/gim,
                path = o.src.split("/");
            path.pop();
            path = path.join("/");
            if (path) {
                content = content
                    .replaceAll(rgx_js, function (x, a, b) {
                        return a + path + "/" + b;
                    })
                    .replaceAll(rgx_css, function (x, a, b) {
                        return a + path + "/" + b;
                    });
            }
        }

        $.html = content; // intotdeauna fac replace de content  ---  daca vreau  aditional --- var wrap =_E() ; wrap.get({src:'....'}).then(r=>{target._(wrap)})
        $.init(); // !!!BAC>>> atentie unele coduri mai vechi nu stiu ca EP.get isi face init si run si mai lanseaza inca odata ex view
        $.run(o.src);
        then.bind($)($); // mancarici sa bag then ca si functie in call_back --- mix de logica
        $.fire("loaded");
        CH.resolve(XHR);
    };
    o.target = $;
    XHR = Q.ajax(o);
    return CH.promise;
};

// EX:   Q("#id_of_elm").tpl({src:"name_of_tamplate_no_extension",A:1,B:2}).then().then().catch()
// clear is default;
EP.tpl = function (o) {
    o.tail({
        into: this,
        record: o.record || false,
        clear: o.hasOwnProperty("clear") ? o.clear : true,
    });
    return template(o);
};


/**
 *  - always a call to https://SBD.myadr.ro/aha/io.php \
 *  single_page_app
 * @example
 * ask(  // no done funtion passed => Promise.resolve
 *      "db\\read.val",
 *      {tb_name:'user_safe',type:2}
 * ).then(Q.ip);
 *
 * ask(   // done & options passed
 *      __read__,
 *      {tb_name: 'user_safe',type: 2},
 *      Q.ip,
 *      null,
 *      {loader: "circle", timeout: 3000}
 * );
 *
 * ask(__code__,{src:"/ret.php"},Q.ip);
 * // similar
 * Q.ajax({src:"~/ret.php?x=1&y=45&z=1",loader:"circle",data:{A:1,B:2},cb:Q.ip});
 *
 * ask( __code__, {src:"it/x/test_oci"}).then(dn);
 *
 *
 *
 *
 * @param {str} keyword "class_name.method_name"
 * @param {{}} POST  {project:1,action:4}
 * @param {fn} done or null
 * @param {fn} fail or null
 * @param {{}} opt
 * @returns {chain|xhr}
 */
// !!!BAC>>> NU ASYNC  ca nu mai pot forta sa intoarca xhr si sa-i fac cancel 
function ask(keyword, POST, done, fail, opt = {}) {
    var C = new Chain();
    var cb = function () {
        // warning
        var warn = this.getResponseHeader("warning");
        warn && dn(warn, "WARNING");

        // error  -- see   \_::fail(error_message,error_code)
        var error_text = this.getResponseHeader("error");
        var error_code = this.header("error_code");
        if (error_text || error_code) {
            if (error_code) {
                // error_code more relevant
                Q.modules("~.error_code_handlers").then((M) => {
                    if (M[error_code] instanceof Function) {
                        M[error_code](error_text); // folosesc textul ca argument
                    }
                    else if (/TE::/.test(error_code)) {
                        let A = error_code.split("::");
                        if (TE.error_handlers && TE.error_handlers[A[1]]) {
                            TE.error_handlers[A[1]](A[2]);
                        } else {
                            dn("Missing Function<br/><div bc vsp2>TE.error_handlers." + A[1] + "</div>", "JS:ERROR")
                        }
                    }
                    else {
                        dn(
                            (M[error_code] || error_code) +
                            (M[error_code]
                                ? ""
                                : "<hr/><m bc>~.error_code_handlers</m> has no <m yc>" +
                                error_code +
                                "</m> definition"),
                            "ERROR <m bc>-- " + error_code + " --</m>"
                        );
                    }
                });
            } else {
                fail ? fail(error_text.trim()) : dn(error_text.trim(), "ERROR");
            }
            //typeof done !== 'function' && C.reject({ error_text, error_code });  // daca merg pe variant  promise tre sa propag esecul
            return;
        }
        // comands
        var code = this.getResponseHeader("code");
        if (code) {
            code = eval(code);
        }
        typeof done === "function" &&
            done(
                this.response, // TextResponse
                code, // evaluated code header --- mai create some variables
                this //   this este XMLHTTPRequest
            );
        C.resolve(this.response);
    };
    Q.ajax({
        src: "/aha/io.php?keyword=" + keyword, // pt $_GET folosesc & ... ex ask("test_code&c=2&caca=pipi",'_::lo($_REQUEST);')
        data: POST,
        method: "POST",
        cb: cb, ...opt
    });
    return C; // !!!BAC>>> mai now am return doar Promise de verificat  
}

//EX      ask.only(!data_required)(keyword,POST,r=>{data_required=r.parsed;}).then
ask.only = function (cond, ...args) {
    return function (keyword, POST, cb = (r) => r) {
        // r=>r is pong function
        var bool = cond instanceof Function ? cond(...args) : cond;
        if (!bool) {
            CH = new Chain();
            CH.resolve(0);
            return CH;
        } else {
            return ask(keyword, POST, "chain").then(cb);
        }
    };
};



// pt QFS -- fac download folosinf engine-ul php 
ask.download = function (FD) { // file_descriptor {qfs:1/0 ,path:' ' , file:' ', }
    var CH = new Chain();
    setTimeout(() => document.documentElement.remA("alt"), 100);
    ask(
        "filesystem.download",
        { download_only: 1, ...FD },
        function (resp, code, req) {
            var type = req.header("type");
            var blob = resp instanceof Blob ? resp : new Blob([resp], { type });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            let cd = req.header("content-disposition");
            let fname =
                cd?.match(/filename="?([^"]+)"?/i)?.[1]
                || FD.name
                || FD.file
                || "download";
            link.download = fname;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href); // TEST:
            CH.resolve({ request: req, responce: blob });
        },
        null,
        { type: "blob" }
    );
    return CH;
};






// ask.opt({loader:"circle"})("_.foo",{A:1}).then(dn)
ask.opt = function (o) {
    return function (a, b, c, d, e = {}) {
        return ask(a, b, c, d, { ...o, ...e })
    }
}

ask.upload = function () { }; // TODO:

ask.log = function (o) {
    var F = new FormData();
    F.load(o);
    return fetch("/aha/io.php?keyword=_.log", { method: "POST", body: F });
};
ask.clr = function () {
    fetch("/aha/io.php?keyword=\\users\\session.empty").then(() => {
        location.reload();
    });
};
ask.ret = () => ask(__code__, { src: "it/x/ret.php?ABC=1" }, Q.ip);
ask.test_mail = () => ask(__code__, { src: "it/x/test_mail.php" }, Q.i);
ask.test_wss = () => ask(__code__, { src: "it/x/test_wss.php" });
ask.test_qric = () => ask(__code__, { src: "it/x/test_qric.php" }, Q.i)
ask.test_oci = () => ask(__code__, { src: "it/x/test_oci.php" }, Q.i)

pathArray = function (x) {
    var ar = x.split("|");
    ar.pop();
    ar.sort();
    for (var e in ar) {
        ar[e] = STEPS_TO_ROOT + ar[e].replace(/\/*/, "");
    }
    return ar;
};

absolutePath = function (href) {
    var link = document.createElement("a");
    link.href = href;
    return link.pathname + link.search + link.hash;
};

Object.defineProperty(XMLHttpRequest.prototype, "header", {
    value: function (str, parsed) {
        return !!parsed
            ? JSON.parse(this.getResponseHeader(str))
            : this.getResponseHeader(str);
    },
});

Object.defineProperty(XMLHttpRequest.prototype, "headers", {
    get: function () {
        let o = {};
        this.getAllResponseHeaders().split("\r\n").map(e => {
            let a = /(.*?):\s*(.*)/.exec(e);
            if (a) { o[a[1]] = a[2]; }
        });
        return o;
    }
});



// orice buton sau anchor element DISABLED refuza sa execute  on('click')
document.addEventListener(
    "click",
    function disabled_ignore_click(ev) {
        if (
            ev.target.hasAttribute("disabled") &&
            (ev.target.hasA("btn") || ev.target.tagName === "A")
        ) {
            ev.stopImmediatePropagation();
            return;
        }
    },
    true
);

// ATENTIE LA OFFICE.js ca incearca sa rescrie

Object.defineProperties(FormData.prototype, {
    load: {
        value: function (d) {
            switch (true) {
                case d instanceof HTMLFormElement: // form
                    d.find("[name]").forEach((i) => {
                        this.delete(i.name);
                        this.append(i.name, i.value);
                    });
                    break;
                case d.__proto__ && d.__proto__.hasOwnProperty("value"): // input, textarea ,x-check etc
                    this.delete(d.name);
                    this.append(d.name, d.value);
                    break;
                default: // raw object
                    for (var v in d) {
                        this.delete(v);
                        // previn trimitere de tag
                        !(d[v] || {}).tagName &&
                            this.append(v, typeof d[v] === "string" ? d[v] : JSON.stringify(d[v]));
                    }
                    break;
            }
        },
        enumerable: true,
    },
    clear: {
        value: function () {
            var k = [];
            for (var key of this.keys()) {
                // here you can add filtering conditions
                k.push(key);
            }
            k.map((key) => this.delete(key));
        },
        enumerable: true,
    },
    rename: {
        value: function (entrie, to) {
            if (this.getAll(entrie).length > 1) {
                throw Error("FormData can't rename multiple values! ");
            }
            let orig = this.get(entrie);
            gettype(orig) === "File"
                ? this.append(to, orig, to)
                : this.append(to, orig);
            this.delete(entrie);
        },
        enumerable: true,
    },
    list: {
        get: function () {
            let o = {};
            for (let [k, v] of this.entries()) {
                var found = this.getAll(k);
                o[k] = found.length > 1 ? found : this.get(k);
            }
            return o;
        },
        enumerable: true,
    },
    uri_get: {
        value: function (O) {
            let s = "",
                N = 0,
                p = "";
            for (let i in O) {
                s += (N ? "&" : "") + encodeURIComponent(i) + "=" + encodeURIComponent(O[i]);
                N++;
            }
            return s;
        },
    },
});



ask.row_full_data = (tb_name, id, cb = nf) => {
    return ask("db\\read.record_full_data", { tb_name, id }, cb).then(r => {
        return r.parsed;
    })
}

ask.fus_actions_disp = () => {
    return ask("users\\get_profile.disp", {}).then(async (r) => {  // verifica  $_SESSION["modules"]->fus === 1 
        let R = r.parsed;
        // console.log(session.disp);
        Object.defineProperty(session, "disp", {
            value: R.disp,
            enumerable: false
        })
        // session.disp = R.disp; // dar vreau sa fie non enumerable ca sa nu se vada in console.log si sa nu se modifice accidental
        FUS = R.fus;
        if (FUS) { // fo.myadr.ro de exemplu nu implementeaza FUS 
            FUS.paths.sort_keys();
            FUS.dpt_name = (unit_id) => {
                if (!+unit_id) { // path given conv to id
                    unit_id = FUS.paths[unit_id];
                }
                if (!unit_id) {
                    return null;
                }
                let dpt = FUS.units[unit_id].dpt;
                return FUS.units[dpt].path;
            }
        }
        window.ACTIONS = R.actions;
        Object.defineProperty(ACTIONS, "dpt_name", {
            value: function (act_id) {
                return FUS.dpt_name((ACTIONS[act_id] || {}).unit);
            },
            enumerable: false
        });
        Object.defineProperty(ACTIONS, 'path', {
            value: function (act_id) {
                return FUS.units[(ACTIONS[act_id] || {})?.unit]?.path;
            },
            enumerable: false
        })
        for (act_id in ACTIONS) {
            let A = ACTIONS[act_id];
            FUS.units[A.unit].actions.push(A);
        }
        window.free_days = R.free_days || [];


        var UNIT_EXT = {};
        Object.defineProperties(UNIT_EXT, {
            paths: {
                get: function () {   // 👈 IMPORTANT: not arrow
                    const result = {};
                    const stack = [this.id];
                    while (stack.length) {
                        const cid = stack.pop();
                        const node = FUS.units[cid];
                        if (!node) continue;
                        result[node.path] = node.id;
                        for (const child of (node.children || [])) {
                            stack.push(child);
                        }
                    }
                    return result; // 👈 stored on node
                }
            },
            has: {
                value: function (v) {
                    const target = FUS.units[v];
                    if (!target) return false;
                    return !!this.paths[target.path];
                }
            }
        });

        FUS.units.scan((k, v) => {
            v.__extend__(UNIT_EXT)
        });




    });


}

/*
 * EX
 *  function F1(){
 *      var ch = new Chain;
 *      ... 
 *      if(cond){ch.resolve(1)}else{ch.reject(-1)}
 *      ...
 *      return ch;
 *  }
 */
function Chain() {
    var resolve, reject, p = new Promise((a, b) => {
        resolve = a;
        reject = b;
    });
    p.tail({ resolve, reject });
    return p;
}








/*
 *  --- dynamic module loading system  --- 
 * incerc sa combin es6 modules syntax cu node.js syntax --- adica --- mdl1.sub_mdl3.set_of_fn1.foo_function()
 *  ---  MARE ATENTIE --- modulele sunt citite asincron => la document_ready anumite functii nu au fost citite --- ATENTIE LA LOGICA DE APLICATIE 
 *    CONVENTIE de adresare a modulelor CH_ROOTED
 *  
 *  aha means __AHA__/js/          | library
 *  ~ means __AHA__/kernel/js/   | shared/common space       
 *  
 *  
 *  ex1: Q.modules("~.foo.m1").then(M=>{ M.function_exported_in_m1_module(); })   inseamna ca vreau sa aduc    /var/www/aha/kernel/js/foo/m1.js  incarc in  Q.modules.foo.m1 si rezolv promisul 
 *  
 *  ex2 Q.modules("^.m1","_.m2, ~.group1.m3).then(  ([ M1, M2, M3 ])  =>  {   M1.foo(); M2.goo();    M3 === Q.module.group1.m3   } )    multiple modules loaded   ARRAY ARGUMENTS   Promise.all syntax
 *  
 *  ex3  [A, B] =  await Q.modules("/js/tests/goo.js","/js/tests/foo.js");
 *  
 */
Q.modules = async function modules(...A) {
    if (Array.isArray(A[0])) {  // array of paths    Q.modules(  [ "~.m3", {B: "/~/js/modules/m2.js"} ]   ).then();
        return Q.modules(...A[0]);
    }
    let ARR = [], L;
    A.map(e => { // positional arguments             Q.modules( m1, m2, ...).then()=>{})
        if (/\//.test(e)) { // standard import notation path (importing from external libs care nu respecta comventia de plasare a modulelor din aha)
            ARR.push(import(e + "?V=" + window.jsvc));
        } else {
            /* dot separation style  !!!BAC>>> */
            //  chrooted to */js/   -- conventia aha de plasare a modulelor este  ['',aha]/js/sub_path/module_name.js
            var P = e.split(".");
            switch (P[0]) {
                case "aha":// __AHA__
                case "~":// __SHARED__  /aha/kernel/   [js,php]:common functionality
                    break;
                default:  // __ROOT__
                    P.unshift(""); // structura uniforma de 3 elemente 
                    break;
            }
            L = P.shift();
            ARR.push(import((L ? "/" + L : "") + "/js/" + P.join("/") + ".js?V=" + window.jsvc));
        }
    });
    return ARR.length === 1 ? ARR[0] : Promise.all(ARR);  // Promise.allSettled fute chestia deci NU 
};

// !!!BAC>>> nu merge cu fallback --- as putea incerca file exists in server dar ma expun la hacking

ask.file = async function (url, json) {
    try {
        const response = await fetch(url);
        if (response.ok) {
            return await json ? response.json() : response.text(); // Return parsed JSON if successful
        } else {
            console.warn('Fetch error:', response.statusText);
            return {}; // Return default response if not OK
        }
    } catch (error) {
        console.error('Network error:', error);
        return {}; // Return default response if fetch fails
    }
}

// downlodeza direct din apache fara suport php
window.download = function (path) {
    let fqurl = /:\/\//.test(path) ? path : location.origin + "/" + path;
    fetch(fqurl)
        .then(response => {
            if (!response.ok) {
                console.log(response.statusText)
                throw new Error('Network response was not ok');
            }
            return response.blob();  // Convert response to Blob
        })
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fqurl.replace(/^.*:\/\//, "");  // Set the desired filename
            a.click();  // Programmatically click the <a> to trigger download
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            console.error('There was an error downloading the file:', error);
        });
}




// pentru citit module scrise in commonjs  :  ex none_modules/szip nu exporta nimic ci defineste window.JSZip
// foloseste _E("script") si onload 
async function ensure(file) {
    if (ensure.loaded[file]) {
        return Promise.resolve(file)
    } else {
        let CH = new Chain,
            s = _E("script").setA({ src: file, ensure: 1 });
        s.on("load", ev => { CH.resolve(file) });
        s.on("error", ev => { throw Error("NOT FOUND SCRIPT " + file) })
        ensure.loaded[file] = 1;
        document.head._(s)
        return CH;
    }
}
ensure.loaded = {};



window.info = {
    __self__: document.currentScript?.src,
    __mem__: {},
    get req_types() {
        return this.__mem__.req_types ??
            ask(__utc__, { tb_name: "req_types" }).then((r) => {
                return this.__mem__.req_types = r.parsed.dict("id", "cod");
            })
    },
    get sfin() {
        return this.__mem__.sfin ??
            ask(__utc__, { tb_name: "ALL_ADR.SFIN" }).then(r => {
                return this.__mem__.sfin = r.parsed.dict("id", "cod");
            });
    },
    get cc() {
        return this.__mem__.cc ?? ask(__utc__, { tb_name: "N_cc" }).then(r => {
            this.__mem__.cc = {};
            window.N_CC = r.parsed
            window.N_CC.map(s => {
                this.__mem__.cc[s.id] = s;
            });
            window.N_CC_BY_ID = this.__mem__.cc;
            return this.__mem__.cc
        });
    }
}
